<template>
  <transition name="el-zoom-in-top">
    <div
      class="content-wrapper"
      v-loading="loading"
    >
      <section class="content-header">
        <ol class="breadcrumb">
          <li>
            <router-link to="/">
              <i class="ti-home"></i>
            </router-link>
          </li>
          <li>
            <router-link :to="{name:'userss'}">
              Users
            </router-link>
          </li>
          <li class="active">
            <a href="#">View Users</a>
          </li>
        </ol>
      </section>
      <!-- Main content -->
      <section class="content user-content">
        <div class="box" v-loading="loading">

          <div class="box-body">
            <el-form
              :model="user"
              label-width="120px"
              label-position="top"
            >
              <el-form-item
                label="Name"
                prop="name"
              >
                {{user.name}}
              </el-form-item>
              <el-form-item
                label="Email"
                prop="email"
              >
                {{user.email}}
              </el-form-item>
              <el-form-item
                label="Role"
                prop="role"
              >
                {{user.role}}
              </el-form-item>
              <el-form-item
                label="Customer"
                prop="customerId"
              >
                {{customer.name}}
              </el-form-item>
            </el-form>
            <hr>

          </div>

          <!-- /.box-body -->
        </div>
      </section>
      <!-- /.content -->
    </div>
  </transition>
</template>
<script>
import {mapActions, mapGetters} from 'vuex'
export default {
  name: 'user-view',
  props: {
    id: {
      required: true
    }
  },
  data () {
    return {
      loading: false,
      user: {
        name: '',
        email: '',
        role: '',
        customerId: undefined,
        password: ''
      }
    }
  },
  methods: {
    ...mapActions('users', ['getUser', 'fetchRoles']),
    ...mapActions('customers', ['fetchCustomers'])
  },
  computed: {
    customer () {
      if (this.customers && this.user.customerId) {
        return this.customers.find(x => x.id === this.user.customerId) || {name: 'disabled'}
      }
      return 'loading...'
    },
    ...mapGetters({
      roles: 'users/roles',
      customers: 'customers/list'
    })
  },
  mounted () {
    this.loading = true
    Promise.all([
      this.getUser(this.id),
      this.fetchRoles(),
      this.fetchCustomers()
    ])
      .then(resp => {
        this.loading = false
        this.user = resp[0].data
      }).catch(_ => {
        this.loading = false
        this.$router.push({ name: '404' })
      })
  }

}

</script>



// WEBPACK FOOTER //
// View.vue?7ad41e6f